import {
  ChevronLeftIcon,
  EllipsisVerticalIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import AppBar from "../../../components/AppBar/AppBar";
import CustomSelect from "../../../components/CustomInput/CustomSelect";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../../components/SecondaryButton/SecondaryButton";
import { Popover } from "@headlessui/react";
import Tooltip from "../../../components/Tooltip/Tooltip";

export default function TopBar({
  isScrolled,
  jobId,
  getJobDetailQuery,
  isStateLoading,
  handleStateChange,
  onSave,
  saveLoading,
  setIsGuideModalOpen,
}) {
  const navigate = useNavigate();

  return (
    <AppBar>
      <header className="py-10">
        <div
          className={`${isScrolled ? "" : "max-w-full lg:px-8 px-4 sm:px-6"}`}
        >
          <nav className="flex items-center space-x-4">
            <div
              className="flex items-center mb-2 hover:cursor-pointer"
              onClick={() => navigate(-1)}
            >
              <ChevronLeftIcon
                className="h-5 w-5 flex-shrink-0 text-gray-100"
                aria-hidden="true"
              />
              <button className="ml-2 text-sm font-medium text-gray-100 hover:text-gray-50">
                Back
              </button>
            </div>
          </nav>

          <div
            className={`items-center grid grid-cols-12 grid-rows-1 ${
              isScrolled
                ? "fixed w-full lg:px-16 px-4 sm:px-6 pt-6 pb-12 top-0 z-10 bg-ramsalab-primary dark:bg-ramsalab-gradient"
                : ""
            }`}
          >
            <h1 className="text-3xl font-bold tracking-tight text-white col-span-10 sm:col-span-8">
              Annotate #{jobId}
              {getJobDetailQuery.data?.task &&
                ` - ${getJobDetailQuery.data?.task.name}`}
            </h1>
            <div className="sm:col-span-4 col-span-2 justify-end gap-2 flex">
              <Tooltip message="User guide">
                <div className="flex items-center">
                  <p className="text-sm font-medium leading-5 text-white dark:text-ramsalab-light-gray hidden sm:block">
                    User Guide :
                  </p>
                  <button
                    className="flex items-center  justify-center rounded-full w-10 h-10 text-white dark:text-ramsalab-light-gray"
                    onClick={() => setIsGuideModalOpen(true)}
                  >
                    <InformationCircleIcon
                      className="w-6 h-6 text-white dark:text-ramsalab-light-gray font-extrabold"
                      aria-hidden="true"
                    />
                  </button>
                </div>
              </Tooltip>
              <div className="block xl:hidden">
                <Popover className="relative">
                  <Popover.Button className="flex items-center  justify-center rounded-full w-10 h-10 text-white dark:text-ramsalab-light-gray">
                    <EllipsisVerticalIcon
                      className="w-6 h-6 text-white dark:text-ramsalab-light-gray font-extrabold"
                      aria-hidden="true"
                    />
                  </Popover.Button>
                  <Popover.Panel className="absolute right-0 z-[10000] mt-2 w-[290px] dark:bg-ramsalab-navy bg-white rounded-md shadow-lg ring-1 ring-black dark:ring-ramsalab-light-navy ring-opacity-5">
                    <div className="p-4">
                      <div className="flex items-center gap-2 ">
                        <p className="text-sm font-medium leading-5 text-gray-700 dark:text-ramsalab-light-gray">
                          State:
                        </p>
                        {isStateLoading ? (
                          <div className="h-8 bg-gray-200 dark:bg-ramsalab-light-navy rounded-md w-full animate-pulse"></div>
                        ) : (
                          <CustomSelect
                            id="state"
                            name="state"
                            options={[
                              "new",
                              "in progress",
                              "completed",
                              "rejected",
                            ].map((val) => ({ label: val, value: val }))}
                            formError={{}}
                            value={getJobDetailQuery.data?.state ?? ""}
                            onChange={(e) =>
                              handleStateChange("state", e.target.value)
                            }
                            defaultValue="Change job state"
                            className={
                              "!mt-0 !text-xs !ring-ramsalab-primary-dark"
                            }
                          />
                        )}

                        <SecondaryButton
                          onClick={() => onSave()}
                          loading={saveLoading}
                          className="w-full text-ramsalab-primary-dark  flex item-center justify-center ring-ramsalab-primary-dark hover:bg-ramsalab-primary-dark dark:hover:bg-ramsalab-primary hover:text-white py-1"
                        >
                          Save
                        </SecondaryButton>
                      </div>
                    </div>
                  </Popover.Panel>
                </Popover>
              </div>

              <div className="hidden xl:flex items-center gap-2">
                <p className="text-sm font-medium leading-5 text-white dark:text-ramsalab-light-gray">
                  State:
                </p>
                {isStateLoading ? (
                  <div className="h-7 w-32 bg-gray-200 dark:bg-ramsalab-light-navy rounded-md animate-pulse"></div>
                ) : (
                  <CustomSelect
                    id="state"
                    name="state"
                    options={[
                      "new",
                      "in progress",
                      "completed",
                      "rejected",
                    ].map((val) => ({ label: val, value: val }))}
                    formError={{}}
                    value={getJobDetailQuery.data?.state ?? ""}
                    onChange={(e) => handleStateChange("state", e.target.value)}
                    defaultValue="Change job state"
                    className={"!mt-0 !text-xs !ring-ramsalab-primary-dark"}
                  />
                )}
                <SecondaryButton
                  onClick={() => onSave()}
                  loading={saveLoading}
                  className="text-ramsalab-primary-dark ring-ramsalab-primary-dark hover:bg-ramsalab-primary-dark py-1 hover:text-white"
                >
                  Save
                </SecondaryButton>
              </div>
            </div>
          </div>
        </div>
      </header>
    </AppBar>
  );
}
